import { matchPath } from "react-router";
import * as ROUTES from "../constants/routes";

export type AppRouteKind =
  | "application"
  | "retailer-application"
  | "authentication"
  | "order-onboarding-flow"
  | "payment-link-flow"
  | "supplier-onboarding-flow";

export type AppRouteMetadata = {
  kind: AppRouteKind;
  sessionRequirement: "complete" | "optional" | "complete-after-authentication";
};

type AppRouteDefinition = AppRouteMetadata & {
  patterns: readonly string[];
};

const ROUTE_DEFINITIONS = [
  {
    kind: "retailer-application",
    sessionRequirement: "complete",
    patterns: [ROUTES.RETAILER_HOME],
  },
  {
    kind: "authentication",
    sessionRequirement: "complete-after-authentication",
    patterns: [`${ROUTES.LOGIN}/*`, `${ROUTES.SIGNUP}/*`],
  },
  {
    kind: "order-onboarding-flow",
    sessionRequirement: "optional",
    patterns: [`${ROUTES.ORDER_SUMMARY}/*`],
  },
  {
    kind: "payment-link-flow",
    sessionRequirement: "optional",
    patterns: [ROUTES.PAYMENT_LINK_REF.pattern],
  },
  {
    kind: "supplier-onboarding-flow",
    sessionRequirement: "complete",
    patterns: [ROUTES.SUPPLIER_ONBOARDING],
  },
] as const satisfies readonly AppRouteDefinition[];

const APPLICATION_ROUTE_METADATA: AppRouteMetadata = {
  kind: "application",
  sessionRequirement: "complete",
};

export const getAppRouteMetadata = (pathname: string): AppRouteMetadata => {
  const definition = ROUTE_DEFINITIONS.find(({ patterns }) =>
    patterns.some((pattern) => matchPath(pattern, pathname)),
  );

  if (!definition) return APPLICATION_ROUTE_METADATA;

  return {
    kind: definition.kind,
    sessionRequirement: definition.sessionRequirement,
  };
};
